import { render, staticRenderFns } from "./emailModel.vue?vue&type=template&id=0fe27978"
import script from "./emailModel.vue?vue&type=script&lang=js"
export * from "./emailModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe27978')) {
      api.createRecord('0fe27978', component.options)
    } else {
      api.reload('0fe27978', component.options)
    }
    module.hot.accept("./emailModel.vue?vue&type=template&id=0fe27978", function () {
      api.rerender('0fe27978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/emailModel.vue"
export default component.exports